<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Imports" />
      <h2><i class="fas fa-plus text-primary mr-2"></i>Imports</h2>
      <BreadCrumbs activeItem="Imports" :crumbs="{ home: 'Dashboard' }"/>
    </template>

    <template v-slot:default>
      <form class="row" @submit.prevent="store">
        <div class="col-12 col-xl-6">
          <card headerStyle="dark" title="" class="mb-3">
            <div class="row">
              <div class="form-group col-12">
                <jet-label for="import_type" value="Select Import Type" />
                <select v-model="form.import_type" class="form-control" id="import_type">
                  <option v-for="type in import_types" :key="type.value" :value="type.value">
                  {{ type.label }}
                  </option>
                </select>
                <jet-input-error :message="form.errors.import_type" class="mt-2" />
              </div>
              <div class="form-group col-12">
                <jet-label for="photo" value="Upload file" />
                <FileUpload
                  ref="uploader"
                  mode="advanced"
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  name="import_file"
                  :customUpload="false"
                  :showUploadButton="false"
                  :showCancelButton="false"
                  @select="(event) => selectFile(event)" >
                  <template #empty>
                    <div class="list-file-select px-3 py-4">
                      <p class="mb-0">Drag and drop the file you want to import here.</p>
                      <p class="mb-0">XLS or XLSX formats accepted.</p>
                    </div>
                  </template>
                </FileUpload>
                <jet-input-error :message="form.errors.import_file" class="mt-2" />
              </div>

              <div class="col-12 bottom-button my-4 float-right text-right">
                <jet-button class="px-5" btnStyle="success" icon="fas fa-plus" :disable="form.processing" type="submit">Import</jet-button>
              </div>
            </div>
          </card>
          
          <div class="" v-if="this.form.import_type === 'import_products'">
            <ExampleProductsImport />
          </div>
        </div>

        <div class="col-12 col-xl-6">
          <card headerStyle="info" title="Import histories">
            <DataTable ref="historiesList"
              v-if="histories && histories.length > 0"
              :paginator="true" :rows="10"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" removableSort
              paginatorPosition="both" currentPageReportTemplate="({first} - {last} of {totalRecords})"
              :rowsPerPageOptions="[10, 20, 50, 100]"
              sortField="id" :sortOrder="-1"
              class="p-datatable-sm admin-datatable"
              tableClass="border-left border-right border-bottom"
              :value="histories"
              dataKey="id">
              <Column field="id" header="#" headerStyle="width: 3em"></Column>
              <Column header="Requested At" field="created_at" headerStyle="width: 10em">
                <template #body="slotProps">
                  {{ moment(slotProps.data.created_at).format('M/D/YY') }}
                </template>
              </Column>
              <Column field="type" header="Request Type">
                <template #body="slotProps">
                  {{ historyTypes[slotProps.data.type] || slotProps.data.type }}
                </template>
              </Column>
              <Column header="Total" field="total_rows" ></Column>
              <Column header="Processed" field="processed_rows"></Column>
              <Column header="Status" >
                <template #body="slotProps">
                  {{slotProps.data.status}}
                  <i class="fas fa-exclamation text-danger" v-if="slotProps.data.status === 'failed'"></i>
                  <i class="fas fa-check text-success" v-if="slotProps.data.status === 'done'"></i>
                </template>
              </Column>
              <Column class="button-container text-nowrap" :exportable="false">
                <template #body="slotProps">
                  <a class="btn-short text-nowrap m-1" btnStyle="dark" title="Download result"
                    v-if="slotProps.data.output_file_link"
                    :href="slotProps.data.output_file_link"
                  >
                    <i class="fas fa-download"></i> View error
                  </a>
                </template>
              </Column>
            </DataTable>
            <h6 v-else>No Reports for selected type</h6>
          </card>
        </div>
      </form>
    </template>
  </layout>
</template>

<script>
  import moment from 'moment'
  import Layout from '@/Shared/Admin/Layout'

  import JetInput from '@/Jetstream/Input'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'
  import BreadCrumbs from '@/Shared/BreadCrumbs'
  import FileUpload from 'primevue/fileupload';
  import ExampleProductsImport from './ExampleProductsImport';
  import { historyTypes } from '@/Consts'

  export default {
    components: {
      JetActionMessage,
      JetInput,
      JetInputError,
      JetLabel,
      Layout,
      BreadCrumbs,
      FileUpload,
      ExampleProductsImport,
    },
    props:  {
      import_types: Array,
      import_file: null,
      histories: Array,
    },
    data() {
      return {
        form: this.$inertia.form({
          import_type: '',
          import_file: null,
        }),
        historyTypes,
      }
    },
    created() {
      this.moment = moment;
    },
    mounted: function() {
      this.form.import_type = this.query?.get('import_type')
    },
    methods: {
      store() {
        this.form.post(this.route('import.import'))
        this.form.import_file = null
        this.$refs.uploader.clear()
      },
      selectFile(event) {
        this.form.import_file = event.files[0]
      },
      getHistories() {
        this.$inertia.reload({
          data: {import_type: this.form.import_type},
          only: ['histories'],
        })
      }
    },
    watch: {
      'form.import_type'(val) {
        this.getHistories()
      }
    }
  }
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
